<ng-container
    *ngIf="notIE; then supported; else notSupported">
</ng-container>

<ng-template #supported>
    <div class="xlate-filterslyt-w" *ngIf="globalService.inTranslationMode()">
        <a href="/manager/index.php?___lt=1&lttype=section&domain=interviews" class="xlate" id="xlate-link" target="_top">{{globalService.getTranslateLinkLabel()}}</a>
    </div>
    <main class="mock-interviews-container">
        <div class="interviews-modal-container"></div>
        <router-outlet></router-outlet>
    </main>
</ng-template>

<ng-template #notSupported>
    <main class="mock-interviews-container">
        <interview-wrapper [title]="'interviews.Browser Detection Heading' | translate">
            <div step-content>
                <div class="body">
                    <p>{{'interviews.Browser Detection' | translate}}</p>
                    <ul>
                        <li><a href="https://www.google.com/chrome" target="_blank">Google Chrome</a></li>
                        <li><a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a></li>
                    </ul>
                </div>
            </div>
        </interview-wrapper>
    </main>
</ng-template>
